import React, { useEffect, useState } from 'react';

import { ButtonTypes } from 'common/components/core/Button/Button';
import ConfirmDialog from 'common/components/core/Dialog/ConfirmDialog';
import type { DialogProps } from 'common/components/core/Dialog/Dialog';
import FlexLayout from 'common/components/core/FlexLayout/FlexLayout';
import Paragraph from 'common/components/core/Paragraph/Paragraph';
import StackingLayout from 'common/components/core/StackingLayout/StackingLayout';
import StatusIcon, { StatusIconTypes } from 'common/components/core/StatusIcon/StatusIcon';

export const SESSION_WARNING_DURATION = 60_000;

export type SessionTimeoutWarningDialogProps = DialogProps & {
  onExtendSession: () => void;
};

export default function SessionTimeoutWarningDialog(props: SessionTimeoutWarningDialogProps) {
  const [secondsRemaining, setSecondsRemaining] = useState(SESSION_WARNING_DURATION / 1000);

  useEffect(() => {
    const startTime = Date.now();

    const intervalId = window.setInterval(() => {
      const elapsedTime = Date.now() - startTime;

      setSecondsRemaining(Math.max(Math.ceil((SESSION_WARNING_DURATION - elapsedTime) / 1000), 0));
    }, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <ConfirmDialog
      className="session-timeout-warning-dialog"
      isOpen={props.isOpen}
      title={
        <FlexLayout itemGap="S" alignItems="center" justifyContent="center">
          <StatusIcon type={StatusIconTypes.WARNING} />
          Session timeout warning
        </FlexLayout>
      }
      confirmButtonLabel="Extend Session"
      confirmButtonProps={{ type: ButtonTypes.PRIMARY }}
      cancelButtonProps={{ style: { display: 'none' } }}
      onConfirm={props.onExtendSession}
    >
      <StackingLayout itemGap="L">
        <Paragraph forceMultiLineHeight={true}>
          Your session is about to expire due to inactivity and will be signed out in{' '}
          <strong>{secondsRemaining} seconds</strong>.
        </Paragraph>
        <Paragraph>Click below to extend your session.</Paragraph>
      </StackingLayout>
    </ConfirmDialog>
  );
}
